import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

export enum E_GmailSnapshotType {
  Inbox = 'Inbox',
  Sent = 'Sent',
  Unread = 'Unread',
}

const GmailSnapshotSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },
  emailId: { type: String, required: true },
  labelIds: { type: [String] },
  emailType: { type: String, enum: E_GmailSnapshotType },
  emailDate: { type: Date },
  created: { type: Date, default: Date.now() },
});

export type T_GmailSnapshot = InferSchemaType<typeof GmailSnapshotSchema> & {
  _id: string;
};

export type T_GmailSnapshotDocument = T_GmailSnapshot & Document;

export { GmailSnapshotSchema };
